<template>
  <div>
    <div class="tabs">
      <span
        v-for="(item, index) in tabs"
        :key="index"
        :class="`tab_item ${tabClass(item)}`"
        @click="selectedTab = item.label"
        >{{ item.label }}</span
      >
      <span
        :class="`tab_item tab_item_primary ${selectedTab === 'files' ? 'tab_item_selected' : ''}`"
        @click="onSelectFiles"
        >附件</span
      >
    </div>
    <div v-show="loading">loading……</div>
    <div class="flex-row tabs">
      <el-button size="mini" type="primary" plain @click="projectDetailInfoVisible = true">全屏展示</el-button>
      <el-button
        v-show="!loading && selectedTab !== 'files' && !editing"
        size="mini"
        type="primary"
        plain
        @click="onEdit"
        >编辑</el-button
      >
      <el-button
        v-show="!loading && selectedTab !== 'files' && editing"
        size="mini"
        type="primary"
        plain
        @click="editing = false"
        >取消</el-button
      >
      <el-button
        v-show="!loading && selectedTab !== 'files' && editing"
        size="mini"
        type="primary"
        plain
        @click="onSave"
        >保存</el-button
      >
      <el-button
        v-show="!loading && selectedTab === 'files'"
        size="mini"
        type="primary"
        plain
        @click="$refs.upload.visible(true)"
        >上传</el-button
      >
    </div>
    <div v-if="!loading" class="main flex-row flex-wrap">
      <!-- 展示 -->
      <div v-if="!editing" class="col-1">
        <div v-if="selectedTab === '寻访方向' && targetCompanies.length > 0" class="info-item">
          <span class="ft-gray">目标公司：</span>
          <el-tag v-for="c in targetCompanies" :key="c" size="mini">{{ c }}</el-tag>
        </div>
        <div v-for="_item in itemsFilter()" v-if="haveContent(_item)" :key="_item.label" class="info-item">
          <div v-if="_item.label === '领导介绍'">
            <div class="info-item"><span class="ft-gray">汇报直线姓名：</span> {{ _item.val.name }}</div>
            <div class="info-item">
              <span class="ft-gray">汇报直线的背景信息及亮点：</span> {{ _item.val.describe }}
            </div>
          </div>
          <div v-else-if="_item.label === '目标人选画像'" class="tag-wrapper">
            <el-tag v-for="val in availableTags" :key="val" size="small">{{ val }}</el-tag>
            <span class="ft-gray">{{ _item.label }}：</span> {{ _item.val }}
          </div>
          <div v-else-if="_item.type === 'checkBox'">{{ _item.label }} <i class="el-icon-check" /></div>
          <div v-else>
            <span class="ft-gray">{{ _item.label }}：</span>
            {{ _item.type !== 'date' ? _item.val.toString() : formatDate(_item.val) }}
          </div>
        </div>
      </div>

      <!-- 编辑 -->
      <div v-if="editing" class="flex-row flex-wrap full-width">
        <div
          v-for="_item in itemsFilter()"
          :key="_item.label"
          :class="`col-1 ${_item.type !== 'textarea' ? 'input-field' : 'full-width input-textarea'}`"
        >
          <el-autocomplete
            v-if="_item.type === 'complete'"
            v-model="_item.val"
            :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb, _item.options)"
            :placeholder="_item.label"
            size="mini"
            @select="
              ;(_item.key === '客户公司' && onChangeCompany(items, _item)) ||
                (_item.key === '职能模块' && onChangeCategory(items[1].children, _item))
            "
          />
          <el-select
            v-else-if="_item.options"
            v-model="_item.val"
            :multiple="_item.multiple"
            :allow-create="_item.allowCreate"
            :filterable="_item.filterable"
            :placeholder="_item.label"
            clearable
            size="mini"
          >
            <el-option
              v-for="(option, i) in _item.options"
              :key="i"
              :value="optionValue(option, _item)"
              :label="optionLabel(option, _item)"
            />
          </el-select>
          <el-rate v-else-if="_item.type === 'rate'" v-model="_item.val" :colors="['#99A9BF', '#F7BA2A', '#F56C6C']" />
          <div v-else-if="_item.type === 'checkBox'" class="checkbox">
            {{ _item.label }}
            <el-checkbox v-model="_item.val" />
          </div>
          <div v-else-if="_item.type === 'range'" class="flex-row item-center">
            <el-input v-model="_item.val[0]" :placeholder="_item.label" size="mini" autosize class="col-1" />
            {{ ' ~ ' }}
            <el-input v-model="_item.val[1]" :placeholder="_item.label" size="mini" autosize class="col-1" />
            {{ _item.append }}
          </div>
          <el-date-picker
            v-else-if="_item.type === 'date'"
            v-model="_item.val"
            :placeholder="_item.label"
            type="date"
            size="mini"
            value-format="timestamp"
            class="input-date mini_datetime_picker"
          />
          <div v-else-if="_item.label === '领导介绍'">
            <el-input v-model="_item.val.name" placeholder="汇报直线姓名" size="mini" class="full-width mb10" />
            <el-input
              v-model="_item.val.describe"
              size="mini"
              type="textarea"
              placeholder="汇报直线的背景信息及亮点"
              autosize
              class="full-width"
            />
          </div>
          <div v-else-if="_item.label === '目标人选画像'" class="tag-wrapper">
            <div v-for="(tagGroup, _index) in tags" :key="_index" class="pd-10">
              <div>{{ tagGroup.label }}</div>
              <div v-if="tagGroup.key === 'other'">
                <el-tag v-for="tag in tagGroup.checkList" :key="tag" closable size="small" @close="removeTag(tag)">{{
                  tag
                }}</el-tag>
                <el-input
                  v-if="inputVisible"
                  ref="saveTagInput"
                  v-model="inputValue"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                />
                <el-button v-else size="small" @click="showInput">+ New Tag</el-button>
              </div>
              <el-checkbox-group v-else v-model="tagGroup.checkList" class="flex-row flex-wrap">
                <el-checkbox v-for="_tag in tagGroup.children" :key="_tag" :label="_tag" class="check-item mr10" />
              </el-checkbox-group>
            </div>
            <el-input
              v-model="_item.val"
              :placeholder="_item.label"
              type="textarea"
              class="pd10"
              size="mini"
              autosize
            />
          </div>
          <el-input
            v-else
            v-model="_item.val"
            :type="_item.type === 'textarea' ? 'textarea' : 'text'"
            :placeholder="_item.label"
            size="mini"
            autosize
          />
        </div>
      </div>
    </div>
    <el-table v-show="selectedTab === 'files'" ref="table" v-loading="loading" :data="files" size="mini" border>
      <el-table-column width="45" label="操作" align="center">
        <template slot-scope="scope">
          <p class="drawer-link" @click="preview(scope.row)">预览</p>
        </template>
      </el-table-column>
      <el-table-column label="文件名">
        <template slot-scope="scope">
          <a :title="scope.row.originalname" class="drawer-link ellipsis" @click="download(scope.row)">{{
            scope.row.originalname
          }}</a>
        </template>
      </el-table-column>
      <el-table-column label="上传人">
        <template slot-scope="scope">
          <p :title="`${scope.row.uploader} ${formatDate(scope.row.createdAt)}`" class="ellipsis">
            {{ scope.row.uploader }} {{ formatDate(scope.row.createdAt) }}
          </p>
        </template>
      </el-table-column>
    </el-table>
    <UploadDialog ref="upload" :on-success="uploadSuccess" label="附件" type="附件" />
    <ProjectDetailInfo
      v-if="projectDetailInfoVisible"
      :project-id="project._id"
      :on-close="
        () => {
          projectDetailInfoVisible = false
        }
      "
      class="fullscreen_wrapper"
    />
  </div>
</template>

<script>
import ProjectDetailInfo from './ProjectDetailInfo.vue'
import { projectEditItems, tags } from '../constant/type'
import { download, preview, onChangeCategory, onChangeCompany } from '../constant/utils'
// 组件已弃用
const dateFormat = require('dateformat')
// TODO refactor
export default {
  components: { ProjectDetailInfo },
  props: {
    pid: { type: String, default: '' },
  },
  data() {
    return {
      tabs: [
        {
          label: '岗位要求',
          actived: true,
        },
        {
          label: '基本信息',
          actived: true,
        },
        {
          label: '岗位职责',
          actived: false,
        },
        {
          label: '寻访方向',
          actived: false,
        },
        {
          label: '职位亮点及优势',
          actived: false,
        },
        {
          label: '薪资架构',
          actived: false,
        },
        {
          label: '职位话述',
          key: '项目话术',
          actived: false,
        },
        {
          label: '目标人选画像',
          key: 'keyWords',
          actived: false,
        },
        {
          label: '部门详情',
          actived: false,
        },
        {
          label: '领导介绍',
          key: '领导',
          actived: false,
        },
        {
          label: '其他',
          actived: false,
        },
      ],
      project: {},
      filesLink: '',
      items: projectEditItems.slice(),
      tags: [],
      inputVisible: false,
      inputValue: '',
      selectedTab: '岗位要求',
      saveLoading: false,
      loading: false,
      files: [],
      editing: false,
      availableTags: [],
      targetCompanies: [],
      projectDetailInfoVisible: false,
    }
  },
  computed: {
    download() {
      return download
    },
    preview() {
      return preview
    },
    onChangeCategory() {
      return onChangeCategory
    },
    onChangeCompany() {
      return onChangeCompany
    },
  },
  watch: {
    pid: {
      async handler(val, oldVal) {
        if (!val) return
        this.loading = true
        await this.getProject()
        this.getCategories()
        this.getCompanies()
        this.getUsers()
        this.refreshTabs()
        this.$nextTick(() => {
          this.loading = false
        })
      },
      immediate: true,
    },
    selectedTab(value, oldVal) {
      if (value === oldVal) return
      this.$forceUpdate()
    },
    tags(value, oldVal) {
      const result = []
      value.map(val => {
        if (val.checkList) {
          result.push(...val.checkList)
        }
      })
      this.availableTags = result
    },
  },
  methods: {
    formatDate(ts) {
      return ts ? dateFormat(new Date(parseInt(ts, 10)), 'yyyy-mm-dd') : ''
    },
    async getProject() {
      const items = this.items
      try {
        const data = await window.app.service('project').fetch(this.pid)
        this.project = Object.assign({}, data)
        this.tags = this.parseTags(data.tag)
        this.targetCompanies = data['目标公司'] || []
        items.map(item => {
          const children = item.children
          if (Array.isArray(children)) {
            children.map(_item => {
              _item.val =
                data[_item.key || _item.label] || (_item.multiple && []) || (_item.type === 'range' && ['', '']) || ''
            })
            return
          }
          if (item.key === '领导') {
            item.val = Object.assign({}, { name: '', describe: '' }, data['领导'])
          } else {
            item.val = data[item.key || item.label] || (item.multiple && []) || ''
          }
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    parseTags(data = {}) {
      const result = tags.slice()
      result.map(tagGroup => {
        tagGroup.checkList = data[tagGroup.key] || []
      })
      return result
    },
    removeTag(tag) {
      const _tags = this.tags
      _tags.map(tagGroup => {
        if (tagGroup.key === 'other') {
          const children = tagGroup.children
          children.splice(children.indexOf(tag), 1)
        }
      })
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput && this.$refs.saveTagInput[0].$refs.input.focus()
      })
    },
    handleInputConfirm(index) {
      const inputValue = this.inputValue
      if (inputValue) {
        const _tags = this.tags
        _tags.map(tagGroup => {
          if (tagGroup.key === 'other') {
            tagGroup.checkList.push(inputValue)
          }
        })
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    async getCategories() {
      if (!this.categories) {
        this.categories = await app.service('project').simpleCategories()
      }
      let defaultCategory
      const options = (this.categories || []).map((val, index) => {
        if (this.project['职能模块'] === val.名称) {
          defaultCategory = {
            label: val.名称,
            value: val.名称,
            细分职能: val['二级职能'] || [],
            擅长方向: val['擅长方向'],
          }
        }
        return {
          label: val.名称,
          value: val.名称,
          细分职能: val['二级职能'] || [],
          擅长方向: val['擅长方向'],
        }
      })
      const items = (this.items && this.items[1] && this.items[1].children) || undefined
      if (!Array.isArray(items)) return
      const target = items.find(item => item.key === '职能模块')
      if (!target) return
      target.options = options
      defaultCategory && this.onChangeCategory(this.items[1].children, null, defaultCategory)
    },
    async getUsers() {
      const res = await app.service('project').simpleUsers()
      const options = res.map((val, index) => ({
        label: val.account,
        value: val.account,
      }))
      const items = (this.items && this.items[0] && this.items[0].children) || undefined
      if (!Array.isArray(items)) return
      for (let i = 0; i < items.length; i += 1) {
        const target = items[i]
        if (target.remote && target.remote === 'users') {
          target.options = options
        }
      }
    },
    async getCompanies() {
      const res = await window.app.service('project').simpleCompanies()
      const options = res.map((val, index) => ({
        label: val.简称,
        value: val.简称,
      }))
      const items = (this.items && this.items[0] && this.items[0].children) || undefined
      if (!Array.isArray(items)) return
      for (let i = 0; i < items.length; i += 1) {
        const target = items[i]
        if (target.remote && target.remote === 'companies') {
          target.options = options
        }
      }
    },
    querySearch(queryString, cb, options) {
      const results = queryString
        ? options.filter(val =>
            val.label
              ? val.label.toLowerCase().includes(queryString.toLowerCase())
              : val.toLowerCase().includes(queryString.toLowerCase()),
          )
        : options
      cb(results)
    },
    onSave() {
      if (this.saveLoading) return
      const param = {}
      const items = this.items
      const _tags = this.tags
      items.map(item => {
        const children = item.children
        if (Array.isArray(children)) {
          return children.map(_item => (param[_item.key || _item.label] = _item.val))
        }
        return (param[item.key || item.label] = item.val)
      })
      param.tag = {}
      _tags.map(tagGroup => {
        param.tag[tagGroup.key] = tagGroup.checkList
      })
      param['目标公司'] = this.targetCompanies
      this.modify(param)
      this.editing = false
    },
    async modify(param) {
      this.saveLoading = true
      try {
        await window.app.service('project').modify({ id: this.project._id, param })
        this.$message({ type: 'success', message: '保存成功' })
        app.root.$refs.main.$refs.projectTable && app.root.$refs.main.$refs.projectTable.getProjects()
        this.refreshTabs()
      } catch (error) {
        this.$message.error(`modify:${error.message}`)
      }
      this.saveLoading = false
    },
    refreshTabs() {
      const { tabs, project } = this
      for (let i = 2; i < tabs.length; i += 1) {
        const val = tabs[i]
        if (val.key === '领导') {
          if (project['领导'] && project['领导'].name) {
            val.actived = true
          } else {
            val.actived = false
          }
        } else if (project[val.key || val.label]) {
          val.actived = true
        } else {
          val.actived = false
        }
      }
    },
    itemsFilter() {
      const result = []
      const { selectedTab, items } = this
      console.log(selectedTab, items)
      items.map(val => {
        if (val.label && val.label === selectedTab) {
          if (val.children) {
            result.push(...val.children)
          } else {
            result.push(...[val])
          }
        }
      })
      return result
    },
    async getProjectFiles() {
      this.loading = true
      const { data } = await window.app.service('file').projectFiles({ query: { projectId: this.project._id } })
      this.files = data
      this.loading = false
    },
    onSelectFiles() {
      this.selectedTab = 'files'
      if (this.filesLink === this.project._id) return
      this.getProjectFiles()
      this.filesLink = this.project._id
    },
    async uploadSuccess(response, file, fileList) {
      try {
        await window.app
          .service('project')
          .insertProjectFile([Object.assign(response[0], { projectId: this.project._id })])
        this.getProjectFiles()
        app.root.$refs.main.$refs.projectTable && app.root.$refs.main.$refs.projectTable.getProjects()
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    haveContent(value) {
      if (value.type === 'range') {
        return value.val && value.val[0] && value.val[1]
      } else if (value.type === 'date') {
        return value.val
      } else if (value.key === 'keyWords') {
        return this.availableTags.length > 0 || (value.val && value.val.length > 0)
      } else if (value.type === 'checkBox') {
        return value.val
      }
      return !!(value.val && value.val.length > 0)
    },
    tabClass(val) {
      let result = ''
      if (this.selectedTab === val.label) {
        result += 'tab_item_selected'
      }
      if (val.key === 'keywords') {
        if (this.availableTags.length > 0) {
          result += ' tab_item_primary'
        } else {
          result += ' tab_item_default'
        }
      } else if (val.actived) {
        result += ' tab_item_primary'
      } else {
        result += ' tab_item_default'
      }
      return result
    },
    pickTargetCompanies() {
          // console.log(companies)
      app.root.$refs.selectCompany.open([], _value => {
        this.targetCompanies = _value
      })
      // window.app.root.$refs.targetCompany.show({
      //   defaultCompanies: [],
      //   onConfirm: _value => {
      //     this.targetCompanies = _value
      //   },
      // })
    },
    onEdit() {
      if (this.selectedTab === '寻访方向') this.pickTargetCompanies()
      this.editing = true
    },
    optionValue(data, item) {
      const value = (data && data.value) || data || ''
      return value
    },
    optionLabel(data, item) {
      const label = (data && data.label) || data || ''
      return label
    },
  },
}
</script>

<style scoped>
.tabs {
  position: relative;
  padding: 5px;
}
.tabs::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 1px;
  background: #e0e0e0;
}
.main {
  padding: 5px;
}
.input-field {
  width: 50%;
  padding: 0 2px;
  margin-bottom: 5px;
  overflow: hidden;
}
.input-field .el-input {
  width: 100%;
}
.input-field .el-select {
  display: block;
}
.input-field .el-date-editor {
  height: auto;
}
.btn {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  padding: 5px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  border-radius: 6px;
  margin: 5px;
}
.btn:hover {
  color: #fff;
  background-color: rgba(64, 158, 255, 0.8);
}
.checkbox {
  line-height: 28px;
}
.item-value {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 5px 20px 5px 8px;
  color: #409eff;
  background-color: rgba(64, 158, 255, 0.1);
}
.el-icon-edit-outline {
  font-size: 16px;
  cursor: pointer;
  color: #409eff;
}
.item-value .el-icon-edit-outline {
  position: absolute;
  right: 0;
  top: 0;
}
.tag-wrapper .el-tag {
  margin: 0 5px 5px 0;
}
.info-item {
  padding-bottom: 5px;
}
</style>
